export default __webpack_public_path__ + "static/06.03-0384a5a2adfe2aa74d66ea08e9a87fad.png";